import type { ReactNode } from 'react';

/**
 * 一个带标签、辅助说明和错误位的输入框。
 *
 * 错误文案跟着字段走而不是堆在表单顶部——出错时眼睛已经在那一格上了。
 */
export function Field({
  id,
  label,
  aux,
  error,
  hint,
  children,
}: {
  id: string;
  label: string;
  aux?: ReactNode;
  error?: string | null;
  hint?: ReactNode;
  children: ReactNode;
}): ReactNode {
  const bad = error !== null && error !== undefined && error !== '';
  return (
    <div className={bad ? 'field bad' : 'field'}>
      <label htmlFor={id}>
        <span>{label}</span>
        {aux !== undefined && <span className="aux">{aux}</span>}
      </label>
      {children}
      {hint}
      {bad && (
        <p className="msg" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

/** 密码强度条。只是给个方向感，真正的下限由「至少 12 位」把着。 */
export function PasswordMeter({ value }: { value: string }): ReactNode {
  let score = 0;
  if (value.length >= 12) score += 1;
  if (value.length >= 16) score += 1;
  if (/[^A-Za-z0-9]/.test(value)) score += 1;
  if (/[A-Z]/.test(value) && /[a-z]/.test(value) && /\d/.test(value)) score += 1;

  const level = value.length === 0 ? 0 : Math.min(4, Math.max(1, score));

  return (
    <div className="meter" data-level={level} aria-hidden="true">
      <i />
      <i />
      <i />
      <i />
    </div>
  );
}

/** 提交按钮：忙的时候换文案并转圈，避免用户重复点。 */
export function BusyButton({
  busy,
  busyLabel,
  children,
  className = 'btn',
  ...rest
}: {
  busy: boolean;
  busyLabel: string;
  children: ReactNode;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>): ReactNode {
  return (
    <button {...rest} className={className} disabled={busy || rest.disabled === true}>
      {busy && <span className="spin" />}
      {busy ? busyLabel : children}
    </button>
  );
}
